import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetUserThirdPartyPurchasesAdmin(
    $input: GetUserThirdPartyPurchasesAdminInput!
  ) {
    getUserThirdPartyPurchasesAdmin(input: $input) {
      count
      yearCounts {
        year
        count
      }
      results {
        id
        fee
        refund
        discount
        credit
        total
        profit
        purchase_date
        status
        order_source
        payment_method
        user {
          id
          first_name
          last_name
          email
          cellphone
        }
        users {
          user {
            id
            name
            first_name
            last_name
            email
            cellphone
          }
          tickets {
            id
            name
            price
            refunded
            credited
            type
          }
        }
        event {
          id
          name
          start_date
          end_date
          status
          tickets {
            id
            name
            price
          }
        }
        track {
          id
          name
        }
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match, location }) => {
    const search = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    const input = {
      user_id: Number(match.params.id),
    };

    if (search.thirdPartyYear) {
      input.year = Number(search.thirdPartyYear);
    }

    if (search.thirdPartyPage) {
      input.page = search.thirdPartyPage;
      input.limit = '15';
    }

    return {
      variables: {
        input,
      },
      fetchPolicy: 'cache-and-network',
    };
  },
  name: 'thirdPartyData',
});
